import * as React from "react";

export class FontFamilyMarkEditor extends React.Component<FontFamilyMarkEditorProps, FontFamilyMarkEditorState> {
    static defaultProps: Partial<FontFamilyMarkEditorProps> = {};

    constructor(props: FontFamilyMarkEditorProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            null
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FontFamilyMarkEditorProps {

}

interface FontFamilyMarkEditorState {

}

//#endregion "My Region"